<script setup>
const props = defineProps({
  currentThought: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <div class="w-full">
    <div class="border border-gray-200 rounded-lg w-full mb-3 px-3 py-2">
      <div class="text-sm font-semibold shimmer">
        {{ props.currentThought?.title }}
      </div>
      <div class="text-xs font-normal text-gray-600">
        {{ props.currentThought?.description }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "../styles/stylesheet.scss";
</style>
